export default {
  settings: 'Asetukset',
  storefront: 'Storefront',
  media: 'Media',
  style: 'Tyyli',
  scripts: 'Skriptit',
  no_google_place: {
    title: 'Yritystä ei ole yhdistetty mihinkään Google-sijaintiin',
    description: 'Yhdistä yritys Google-sijaintiin',
  },
};
